import { render, staticRenderFns } from "./StudyShortDialog.vue?vue&type=template&id=6ec027fa"
import script from "./StudyShortDialog.vue?vue&type=script&lang=js"
export * from "./StudyShortDialog.vue?vue&type=script&lang=js"
import style0 from "./StudyShortDialog.vue?vue&type=style&index=0&id=6ec027fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports